export const LeafType = {
  bold: 'bold',
  italic: 'italic',
  underline: 'underline',
  code: 'code',
};
